import { Injectable } from '@angular/core';
import { MediaAssetUrls } from '@core/media/models/media-urls.models';
import {
  ProductFormChangeSnapshot,
  ProductModifierGroupDraft,
  ProductVariantEditor,
} from '@features/catalog/models/product-form-draft.models';
import { CreateProductBundleModifierGroupInput } from '@features/catalog/models/product-input.models';
import { ProductModifierGroup } from '@features/catalog/models/product.models';
import {
  mapModifierGroupsFromProduct,
  mapModifierGroupsToBundleInput,
  mapModifierGroupsToChangeSnapshot,
  mapModifierGroupsToStructureSnapshot,
  patchModifierOptionImage,
  patchModifierOptionImageUrl,
} from '@features/catalog/utils/product-form-modifier-draft.mapper';
import { validateModifierGroupsDraft } from '@features/catalog/utils/product-modifier-groups.validation';

@Injectable()
export class ProductFormModifierOrchestrationService {
  mapGroupsFromProduct(
    groups: readonly ProductModifierGroup[] | null | undefined,
    createTempId: () => string
  ): ProductModifierGroupDraft[] {
    return mapModifierGroupsFromProduct(groups ?? [], createTempId);
  }

  mapGroupsToChangeSnapshot(
    groups: readonly ProductModifierGroupDraft[]
  ): ProductFormChangeSnapshot['modifierGroups'] {
    return mapModifierGroupsToChangeSnapshot(groups);
  }

  mapGroupsToStructureSnapshot(
    groups: ProductFormChangeSnapshot['modifierGroups']
  ): unknown {
    return mapModifierGroupsToStructureSnapshot(groups);
  }

  mapGroupsToBundleInput(
    groups: readonly ProductModifierGroupDraft[],
    productVariants: readonly ProductVariantEditor[]
  ): CreateProductBundleModifierGroupInput[] {
    return mapModifierGroupsToBundleInput(groups, productVariants);
  }

  validateGroupsForSave(
    groups: readonly ProductModifierGroupDraft[],
    productVariants: readonly ProductVariantEditor[],
    isVariable: boolean
  ): void {
    const hasActiveVariants =
      isVariable && productVariants.some((variant) => variant.active !== false);
    validateModifierGroupsDraft(groups, hasActiveVariants);
  }

  patchOptionImage(
    groups: readonly ProductModifierGroupDraft[],
    groupTempId: string,
    optionTempId: string,
    patch: { imageUrl: string | null; imageUrls?: MediaAssetUrls | null }
  ): ProductModifierGroupDraft[] {
    return patchModifierOptionImage(groups, groupTempId, optionTempId, patch);
  }

  patchOptionImageUrl(
    groups: readonly ProductModifierGroupDraft[],
    groupTempId: string,
    optionTempId: string,
    imageUrl: string | null
  ): ProductModifierGroupDraft[] {
    return patchModifierOptionImageUrl(groups, groupTempId, optionTempId, imageUrl);
  }
}
